module.exports = __webpack_public_path__ + "static/media/cf.6b95f77c.svg";